
// This function will take a string and convert it
// to one that is in a valid machine string that can
// be used to build up channel address, etc.
export function sanitizeNameString(input: string): string {

    let temp = input.toLowerCase().trim()
    temp = temp.replace(/ /g,"_")
    temp = temp.replace(/-/g,"_")
    temp = temp.replace(/[^a-z0-9_]/g, "")
    temp = temp.replace(/_+/g,"_")

    if(!!parseInt(temp[0])) {
        temp = "_" + temp
    }



    return temp
}